import { ReactNode } from "react";
import Sidebar from "../../components/sidebar/Sidebar";

const MainLayout = ({ children }: { children: ReactNode }) => {
  return (
    <div className="main">
      <div className="main-sidebar ">
        <Sidebar />
      </div>

      <div className="main-contents ">
        <div className="main-children ">{children}</div>
      </div>
    </div>
  );
};

export default MainLayout;
